const getters = {
  token: state => state.user.token,
  bindPhone: state => state.user.bindPhone,
  bindSSI: state => state.user.bindSSI
}

export default getters

